<script>
export default {
  name: "AppBestSeller",
  computed: {
    bestSellerProducts() {
      return this.$store.getters.bestSellerProducts;
    },
  },
};
</script>

<template>
  <h2>Bestseller</h2>
  <section>
    <div
      class="bestitems"
      v-for="product in bestSellerProducts"
      :key="product.id"
    >
      <div class="item">
        <div class="image">
          <router-link :to="`/${product.category}/${product.id}`">
            <img :src="`Products/${product.img}`" alt="" />
            <div class="variant">
              <img
                :src="`/Products/${product.sub}`"
                alt=""
                class="sub-image"
                loading="eager"
                decoding="async"
              />
              <span>View Product</span>
            </div>
          </router-link>
        </div>
        <h3>{{ product.name }}</h3>
        <p>${{ product.price }}</p>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
h2 {
  text-align: center;
  font-size: 2.5rem;
  font-family: Poppins;
  font-weight: 650;
  color: #2b2b2b;
  text-transform: none;
  margin-top: 5rem;
  margin-bottom: 0;
}

section {
  margin: auto;
  width: 80%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 1fr;
}

.bestitems {
  grid-gap: 20px;
  justify-content: center;

  .image {
    display: inline-block;
    position: relative;

    .sub-image {
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: auto;
    }

    span {
      display: none;
    }

    &:hover .sub-image {
      display: flex;
      height: auto;
      width: 100%;
    }

    &:hover span {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: 95%;
      left: 50%;
      width: 100%;
      height: 10%;
      transform: translate(-50%, -50%);
      font-size: 0.9rem;
      font-weight: 600;
      color: #ffffff;
      background-color: #575757;
      text-transform: capitalize;
      font-family: Poppins;
      animation: slide-up 0.3s ease-in-out;

      @keyframes slide-up {
        0% {
          transform: translate(-50%, 0);
        }

        100% {
          transform: translate(-50%, -50%);
        }
      }
    }
  }

  h3,
  p,
  button {
    margin: 5px auto;
  }

  .item {
    border-radius: 15px;
    background: #ffffff;
    padding: 10px 20px 30px;
    min-height: 150px;
    justify-self: center;
    align-self: center;
    text-align: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }

    h3 {
      font-family: Poppins;
      font-weight: 900;
      color: #2b2b2b;
      text-transform: none;
    }

    p {
      font-family: Poppins;
      font-weight: 400;
      color: #2b2b2b;
      text-transform: none;
    }
  }

  svg {
    width: 15px;
  }
}

@media screen and (max-width: 1024px) {
  section {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
